import api from "./api";

// Capa de servicios API de la disponibilidad por profesional (doc 0396).
// Wrappers de transporte finos: el endpoint se centraliza aquí, la construcción
// del payload vive en el componente.

export const getProfessionalHours = (professionalId) =>
  api.get(`/professional-hours/${professionalId}`);

/**
 * Sustituye la semana completa. Es PUT y no PATCH a propósito: el editor manda
 * todos los días, y lo que no se envía deja de existir.
 */
export const saveProfessionalHours = (professionalId, slots) =>
  api.put(`/professional-hours/${professionalId}`, { slots });
